import createModel from './lib/create_model';

export default createModel({
  modelName: 'TaskDueContent',

  properties: {
    taskItemId: String,
  },

  statics: {
    create(attrs) {
      return new this(attrs);
    },
  },
});
